
(function() {
  // ===== BUTANI MEGA MENU (matches butani.com) =====
  var MEGA_MENUS = {
    'jewellery': {
      columns: [
        { title: 'COLLECTION', links: [
          { text: 'Bloom', url: '/pages/collection-bloom' },
          { text: 'Deco', url: '/pages/collection-deco' },
          { text: 'Metropolitan', url: '/pages/collection-metropolitan' },
          { text: 'Nova', url: '/pages/collection-nova' }
        ]},
        { title: 'CATEGORIES', links: [
          { text: 'Rings', url: '/pages/jewellery-rings' },
          { text: 'Bracelets', url: '/pages/jewellery-bracelets' },
          { text: 'Necklaces', url: '/pages/jewellery-necklaces' },
          { text: 'Earrings', url: '/pages/jewellery-earrings' }
        ]},
        { title: 'SELECTION', links: [
          { text: 'Stackables', url: '/collections/stackables' },
          { text: 'Most Popular', url: '/collections/most-popular' },
          { text: 'Tetra', url: '/collections/tetra' }
        ]}
      ]
    },
    'high jewellery': {
      columns: [
        { title: 'COLLECTION', links: [
          { text: 'Bloom', url: '/pages/collection-bloom' },
          { text: 'Deco', url: '/pages/collection-deco' },
          { text: 'Metropolitan', url: '/pages/collection-metropolitan' },
          { text: 'Nova', url: '/pages/collection-nova' }
        ]},
        { title: 'CATEGORIES', links: [
          { text: 'Rings', url: '/pages/jewellery-rings' },
          { text: 'Bracelets', url: '/pages/jewellery-bracelets' },
          { text: 'Necklaces', url: '/pages/jewellery-necklaces' },
          { text: 'Earrings', url: '/pages/jewellery-earrings' }
        ]}
      ]
    },
    'bridal': {
      columns: [
        { title: 'BRIDAL', links: [
          { text: 'Bridal & Engagement', url: '/pages/bridal' },
          { text: 'Bridal Jewellery', url: '/pages/bridal' },
          { text: 'Engagement Rings', url: '/pages/bridal' },
          { text: 'Wedding Bands & Eternity Rings', url: '/pages/bridal' },
          { text: 'Custom Bridal', url: '/pages/bridal' }
        ]}
      ]
    }
  };

  var STYLE = document.createElement('style');
  STYLE.textContent = `
    .butani-mega { display:none; position:absolute; top:100%; left:50%; transform:translateX(-50%);
      background:#FFFFFF; border-top:1px solid #eee; box-shadow:0 12px 40px rgba(0,0,0,0.12);
      padding:36px 48px; z-index:9999; min-width:680px; }
    .butani-mega.open { display:flex; gap:56px; }
    .butani-mega__col h4 { font-family:'Playfair Display',serif; font-size:13px; letter-spacing:0.22em;
      color:#B08D57; margin:0 0 18px; font-weight:600; }
    .butani-mega__col a { display:block; font-family:'Playfair Display',serif; font-size:15px;
      letter-spacing:0.08em; color:#1A1A1A; text-transform:uppercase; padding:7px 0; text-decoration:none; }
    .butani-mega__col a:hover { color:#B08D57; }
    .butani-nav-item { position:relative; }
  `;
  document.head.appendChild(STYLE);

  function buildMega(menu) {
    var panel = document.createElement('div');
    panel.className = 'butani-mega';
    menu.columns.forEach(function(col) {
      var colEl = document.createElement('div');
      colEl.className = 'butani-mega__col';
      var h = document.createElement('h4');
      h.textContent = col.title;
      colEl.appendChild(h);
      col.links.forEach(function(link) {
        var a = document.createElement('a');
        a.href = link.url;
        a.textContent = link.text;
        colEl.appendChild(a);
      });
      panel.appendChild(colEl);
    });
    return panel;
  }

  function setup() {
    var links = document.querySelectorAll('#shopify-section-header .tier-1 > ul > li > a');
    links.forEach(function(a) {
      var text = (a.textContent || '').trim().toLowerCase();
      var menu = MEGA_MENUS[text];
      if (!menu) return;
      var li = a.parentElement;
      li.classList.add('butani-nav-item');
      var panel = buildMega(menu);
      li.appendChild(panel);
      var show = function() { panel.classList.add('open'); };
      var hide = function() { panel.classList.remove('open'); };
      li.addEventListener('mouseenter', show);
      li.addEventListener('mouseleave', hide);
      a.addEventListener('mouseenter', show);
      a.addEventListener('click', function(e) {
        // First click toggles menu; keep link working
        if (!panel.classList.contains('open')) { e.preventDefault(); panel.classList.add('open'); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  setTimeout(setup, 600);
  setTimeout(setup, 2000);
})();
